import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { GuestRole } from '../models/guest-role.model';
import { GuestRoleFilter } from '../models/guest-role-filter.model';
import { Guest, NetworkAccountStatus, ResultWithEntity } from '../models';

@Injectable()
export class GuestRoleService {
  private url = 'api/guestRoles' as const;

  constructor(private http: HttpClient) {}

  getGuestRoleById(guestRoleId: number): Observable<GuestRole> {
    return this.http.get<GuestRole>(`${this.url}/${guestRoleId}`);
  }

  getFilteredGuestRoles(filter: GuestRoleFilter): Observable<GuestRole[]> {
    return this.http.get<GuestRole[]>(`${this.url}`, {
      params: {
        guestRoleFilter: JSON.stringify(filter),
      },
    });
  }

  createGuestRole(
    guestRole: GuestRole
  ): Observable<ResultWithEntity<GuestRole>> {
    return this.http.post<ResultWithEntity<GuestRole>>(
      `${this.url}`,
      guestRole
    );
  }

  updateGuestRole(guestRole: GuestRole): Observable<GuestRole> {
    return this.http.put<GuestRole>(`${this.url}`, guestRole);
  }

  getNetworkAccountStatus(inumber: string, guestRoleId: number): Observable<NetworkAccountStatus> {
    return this.http.get<NetworkAccountStatus>(`${this.url}/network-account-status`, {
      params: {
        inumber: inumber,
        guestRoleId: guestRoleId,
      },
    });
  }

  resendSetupEmail(inumber: string, guestRoleId: number): Observable<void> {
    return this.http.post<void>(`${this.url}/resend-setup-email`, {}, {
      params: {
        inumber: inumber,
        guestRoleId: guestRoleId,
      }
    });
  }
}
